import React from "react";
import { Carousel, Row, Col, Card, NavLink } from "react-bootstrap";
import { Link } from "react-router-dom";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

export default function Sponsors({ sponsorList }) {
  const sponsors = sponsorList || [];

  const chunkSlides = [];
  for (let i = 0; i < sponsors.length; i += 6) {
    chunkSlides.push(sponsors.slice(i, i + 6));
  }

  return (
    <section className="sponsors-section my-5 py-5">
      {/* Title Row */}
      <div className="d-flex justify-content-center text-center mb-4">
        <div className="d-flex justify-content-center align-items-center flex-column ms-auto home-headers">
          <h2 className="team-title mb-2 h1">Sponsers</h2>
        </div>
        <NavLink as={Link} to="/sponsor" className="view-all-link ms-auto">
          View All
        </NavLink>
      </div>

      {/* Carousel */}
      <Carousel
        indicators
        interval={3000}
        controls={false}
        className="sponser-carousel"
      >
        {chunkSlides.map((group, i) => (
          <Carousel.Item key={i}>
            <Card className="sponsor-card radius-lg">
              <Row className="gx-3">
                {group.map((data, index) => (
                  <Col
                    xs={6}
                    sm={4}
                    md={4}
                    lg={2}
                    key={index}
                    className="text-center mt-2 mb-2"
                  >
                    <div className="sponsor-box d-flex align-items-center justify-content-center">
                      {data?.website_link ? (
                        <a
                          href={data.website_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${IMAGE_BASEURL}${data.logo_path}`}
                            alt={data?.name}
                            className="sponsor-img"
                          />
                        </a>
                      ) : (
                        <img
                          src={`${IMAGE_BASEURL}${data.logo_path}`}
                          alt={data?.name}
                          className="sponsor-img"
                        />
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            </Card>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
}
